module.exports = __webpack_public_path__ + "img/login.b69ac9b2.svg";